<template>
  <el-row class="type-container"
          :gutter="10">
    <el-col :xs="24"
            :span="5">
      <el-card shadow="none">
        <div slot="header"
             class="pt-5 pb-5">
          <i class="el-icon-discount mr-10"></i>时段管理组
        </div>
        <el-tree highlight-current
                 class="time-tree"
                 ref="timeTree"
                 node-key="id"
                 :expand-on-click-node="false"
                 :current-node-key="currentKey"
                 :data="tabList"
                 :props="defaultProps"
                 @node-click="handleNodeClick">
          <span class="custom-tree-node"
                slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button v-has="'/time_slot/edit'"
                         type="text"
                         size="mini"
                         icon="el-icon-edit"
                         @click.stop="() => editName(node, data)"></el-button>
            </span>
          </span>
        </el-tree>
      </el-card>
    </el-col>
    <el-col :xs="24"
            :span="19">
      <el-card shadow="none">
        <el-table max-height="605"
                  :data="tableData">
          <el-table-column type="index"
                           label="序号"
                           width="60">
          </el-table-column>
          <el-table-column v-for="(item, index) in tableTitle"
                           :key="index"
                           :label="item.name"
                           :prop="item.prop"
                           :min-width="item.width"
                           :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="操作"
                           width="90">
            <template slot-scope="scope">
              <el-button v-has="'/time_slot/edit'"
                         size="mini"
                         type="primary"
                         @click="editTime(scope.row)">编辑</el-button>
              <!-- <el-button size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <Pagination :total="pagination.total"
                    :current="pagination.currentPage"
                    :pageSize="pagination.perPage"
                    @handleSizeChange="handleSizeChange"
                    @handleCurrent="handleCurrentChange"></Pagination>
      </el-card>
    </el-col>
    <add-time v-if="showTimeModal"
              :isShow="showTimeModal"
              :data="timeData"
              @handleClose="closeTimeModal"></add-time>
  </el-row>
</template>
<script>
import fetch from '@/common/api'
import AddTime from '@/views/basic/time/AddTime'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { AddTime, Pagination },
  data() {
    return {
      currentKey: '',
      defaultProps: {
        label: 'name'
      },
      tabList: [],
      tableTitle: [
        {
          prop: 'name',
          name: '日期',
          width: '100'
        },
        {
          prop: 'time1',
          name: '时间',
          width: '100'
        }
      ],
      tabData: [],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 添加时段相关
      showTimeModal: false,
      timeData: {
        type: 'add'
      }
    }
  },
  mounted() {
    this.getList().then(() => {
      this.getInfo()
    })
  },
  methods: {
    // 获取列表
    getList() {
      return Promise.resolve(
        fetch.getTimeList({}).then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.tabList = data.list
              this.currentKey = data.list[0].id
              this.$nextTick(function () {
                this.$refs.timeTree.setCurrentKey(data.list[0].id)
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
      )
    },
    // 获取右侧数据
    getInfo() {
      return Promise.resolve(
        fetch.getTimeInfo({ id: this.currentKey }).then((data) => {
          data.procData(
            data.res,
            (data) => {
              let tmpArr = []
              tmpArr.push(data.w1)
              tmpArr.push(data.w2)
              tmpArr.push(data.w3)
              tmpArr.push(data.w4)
              tmpArr.push(data.w5)
              tmpArr.push(data.w6)
              tmpArr.push(data.w7)
              let datas = []
              let weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
              datas = tmpArr.map((item, index) => {
                let splitArr = item.split(',')
                let obj = {}
                let num = 0
                for (var i = 0, len = splitArr.length; i < len; i += 2) {
                  num++
                  obj['time' + num] = splitArr.slice(i, i + 2).join('-')
                }
                return {
                  id: 'w' + (index + 1),
                  name: weekArr[index],
                  ...obj
                }
              })
              this.tableData = datas
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
      )
    },
    // 树形菜单单击
    handleNodeClick(data) {
      if (data.id !== this.currentKey) {
        this.currentKey = data.id
        this.getInfo()
      }
    },
    // 编辑时段
    editName(node, data) {
      this.showTimeModal = true
      this.timeData = {
        pId: data.id,
        type: 'edit',
        item: 'name'
      }
    },
    // 编辑类目
    editTime(data) {
      this.showTimeModal = true
      this.timeData = {
        pId: this.currentKey,
        type: 'edit',
        id: data.id,
        time: data.time1
      }
    },
    // 关闭添加类目弹窗
    closeTimeModal(way) {
      console.log(way)
      if (way === 'left') {
        this.getList()
      } else {
        this.getInfo()
      }
      this.showTimeModal = false
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(data.id)
          this.$message.success('操作成功')
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="less">
.type-container {
  .el-tree-node__content {
    height: 40px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}
</style>
